export function stringToKebabCase(str) {
    return str
        .replace(/([a-z])([A-Z])/g, '$1-$2') // Add hyphen before uppercase letters
        .replace(/[\s_]+/g, '-') // Replace spaces and underscores with hyphens
        .toLowerCase();
}
//# sourceMappingURL=stringToKebabCase.js.map